import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { miEnvironment } from '../mobile-instructions-environment';
import { instructionResponseSchema } from '../schemas/instruction-response.schema';
import { MobileInstructionGroup } from '../schemas/mobile-instructions.schema';

/**
 * Posts instructions at the vehicle group level
 * @param instructions The instructions
 * @returns Response indicating success and the id of the newly created instruction
 */
export function postInstructionVehicleGroups(
  this: unknown,
  instructions: MobileInstructionGroup
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(miEnvironment.resolve(this).instructionVehicleGroupsUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(instructions),
      })
    )
  ).pipe(selectData(instructionResponseSchema));
}
